import { getCurrentInstance } from 'vue'
import { getVueContext } from 'src/common/context'

export function useHelpers(instance = getCurrentInstance()) {
  const vueInstance = instance?.appContext || getVueContext()
  return vueInstance ? vueInstance.config.globalProperties.$helpers : {}
}
